import React, { Component } from "react";
import styles from "../../../assets/css/modules/containers/shadowed-container.css";

const leaverBackground ={
  background: '#4976BA',
  color: 'white',
};
export default class ShadowedContainerSME extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div
              className={
                this.props.className +
                " " +
                styles.shadowedContainer +
                " children" 
              }
              style={leaverBackground}
            >
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
